<template>
    <span
        v-html="$t('notification.reservationUpdatedPlan', {name:$_.get(activity, 'actorUser.name'),title:$_.get(activity, 'payload.title')})"></span>
</template>
<script>
export default {
    name: "ReservationUpdated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
<style></style>
